import React, { useEffect, useRef } from "react";

import { PowerBiurl } from "../../Container/BaseUrl/BaseUrl";

import * as pbi from "powerbi-client";

import axios from "axios";

const Powerbi = () => {
  const reportContainerRef = useRef(null);

  const fetchEmbedData = async () => {
   
    const access_token = localStorage.getItem("access_token");
    const tenantId = localStorage.getItem("TenantId");
    try {
      const response = await axios.get(PowerBiurl + "v1/powerBi/getEmbedToken", {
        headers: {
          Authorization: "Bearer " + access_token,
          "Content-Type": "application/json",
          tenantId: tenantId,
        },
      });
      
      const embedData = response;
      const models = pbi.models;
      const reportLoadConfig = {
        type: "report",
        tokenType: models.TokenType.Embed,
        accessToken: embedData.data.accessToken,
        embedUrl: embedData.data.embedUrl[0].embedUrl,
      };
      console.log("Hiiii",reportLoadConfig)
      const report = window.powerbi.embed(
        reportContainerRef.current,
        reportLoadConfig
      );
      report.off("loaded");
      report.on("loaded", () => {});
      report.off("rendered");
      report.on("rendered", () => {});
      report.off("error");
      report.on("error", (event) => {
        const errorMsg = event.detail;
        return;
      });
    } catch (error) {}
  };

  useEffect(() => {
    fetchEmbedData();
  }, []);

  return (
    <>
      <div
        ref={reportContainerRef}
        id="report-container"
        style={{
          padding: "1rem",
    height: "calc(100vh - 70px)",
        }}
      />
    </>
  );
};

export default Powerbi;

// import React from "react";

// const Powerbi = () => {
//   return (
//     <>
//       <div className="d-flex justify-content-center h-100 w-100">
//         <iframe
//           src="https://app.powerbi.com/reportEmbed?reportId=64fd0523-5af2-407e-9ae7-14910a337c1f&autoAuth=true&ctid=7433e884-416d-49a2-81a4-5cedf12536e6"
//           style={{
//             width: "96%",
//             height: "97vh",
//             position: "relative",
//             top: "-40px",
//             left: "50px",
//           }}
//         ></iframe>
//       </div>
//     </>
//   );
// };

// export default Powerbi;
